// extracted by mini-css-extract-plugin
module.exports = {"hidden":"loader_hidden__2NcYC","visible":"loader_visible__3Z9WV","block":"loader_block__2oUNW"};